import { ApiError } from '@maestro/data-layer'

/**
 * When an API route re-throws a redirect error (e.g. to /logout),
 * fetch follows it silently without navigating the page.
 * Detect this and force a hard navigation so the browser actually
 * completes the logout/redirect flow.
 */
function handleRedirectedResponse(response: Response): void {
  if (response.redirected) {
    window.location.assign(response.url)
    throw new ApiError('Redirected', 0)
  }
}

export async function apiGet<T>(
  path: string,
  params?: Record<string, string | undefined>
): Promise<T> {
  const url = new URL(path, window.location.origin)
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined) {
        url.searchParams.set(key, value)
      }
    }
  }

  const response = await fetch(url.toString())
  handleRedirectedResponse(response)
  if (!response.ok) {
    throw new ApiError(
      `API error: ${response.status} ${response.statusText}`,
      response.status
    )
  }
  return response.json()
}

export async function apiPost<T>(path: string, body: unknown): Promise<T> {
  const response = await fetch(path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  handleRedirectedResponse(response)
  if (!response.ok) {
    throw new ApiError(
      `API error: ${response.status} ${response.statusText}`,
      response.status
    )
  }
  return response.json()
}
